(function(){
  var rail=document.getElementById("ugcRail");if(!rail)return;
  /* Videos default to muted (autoplay-safe). Tapping a card toggles play/pause;
     the corner speaker button unmutes/mutes. Only one clip ever has sound or
     plays at a time. The "playing" state is driven by the video's own play/pause
     events so it can't get out of sync with rapid taps. */
  function setSound(card,v,on){v.muted=!on;card.classList.toggle("sound-on",on);var b=card.querySelector(".ugc-sound");if(b)b.setAttribute("aria-label",on?"Mute":"Unmute");}
  function stopOthers(v){[].forEach.call(rail.querySelectorAll("video"),function(o){if(o!==v){o.pause();var c=o.closest(".ugc-card");if(c)setSound(c,o,false);}});}
  rail.addEventListener("click",function(e){
    var card=e.target.closest(".ugc-card");if(!card)return;
    var v=card.querySelector("video");if(!v||!v.querySelector("source"))return;
    if(e.target.closest(".ugc-sound")){
      if(v.muted){stopOthers(v);setSound(card,v,true);if(v.paused)v.play().catch(function(){});}  /* turn sound on (and start playing) */
      else{setSound(card,v,false);}                                                                /* mute, keep playing */
      return;
    }
    if(v.paused){stopOthers(v);v.play().catch(function(){});}
    else{v.pause();}
  });
  [].forEach.call(rail.querySelectorAll("video"),function(v){
    var card=v.closest(".ugc-card");if(!card)return;
    v.addEventListener("play",function(){card.classList.add("playing");});
    v.addEventListener("pause",function(){card.classList.remove("playing");});
    v.addEventListener("ended",function(){card.classList.remove("playing");});
  });
})();
;
(function(){var rail=document.getElementById("crewRail"),dw=document.getElementById("crewDots");if(!rail||!dw)return;var cards=rail.querySelectorAll(".crew-card"),dots=dw.querySelectorAll(".crew-dot");function idx(){var c=cards[0];if(!c)return 0;return Math.round(rail.scrollLeft/(c.getBoundingClientRect().width+16));}var crewTick=false,crewLast=-1;rail.addEventListener("scroll",function(){if(crewTick)return;crewTick=true;requestAnimationFrame(function(){crewTick=false;var i=Math.min(dots.length-1,Math.max(0,idx()));if(i===crewLast)return;crewLast=i;dots.forEach(function(d,k){d.classList.toggle("on",k===i);d.setAttribute("aria-current",k===i?"true":"false");});});},{passive:true});dots.forEach(function(d,k){d.addEventListener("click",function(){var c=cards[k];if(c)rail.scrollTo({left:c.offsetLeft-(rail.clientWidth-c.clientWidth)/2,behavior:"smooth"});});});})();
;

(function(){
  "use strict";
  var ACCENT = "#1B2E72";

  /* ---------- state ---------- */
  var state = { cats: 1, plan: "sub", cartCount: 0 };
  var lastFourPlus = 4; // remembers the user's most recent 4+ count so re-selecting "4+" restores it

  /* ---------- helpers ---------- */
  function $(id){ return document.getElementById(id); }
  function basePrice(cats){ return cats <= 3 ? ({1:27,2:50,3:70})[cats] : cats*20; }
  function fmt(n){ return "$" + (Number.isInteger(n) ? n : n.toFixed(2)); }

  /* Shopify variant map (one-time packs). Subscription selling_plan is unknown — placeholder below. */
  var VARIANTS = { 1:55180004491432, 2:55180004524200, 3:55180004556968, 4:55576896635048, 5:55579467841704, 6:55579467874472, 7:55579467907240, 8:55579467940008, 9:55579467972776, 10:55579468005544, 11:55579468038312, 12:55579468071080 };
  // PLACEHOLDER: set a real selling_plan id here once known to add Subscribe & Save line items.
  var SUBSCRIPTION_SELLING_PLAN = 2785575080; /* Subscribe and Save — Deliver every 4 weeks */
  function variantForCats(c){ return VARIANTS[c] || VARIANTS[12]; }

  /* ---------- pricing render ---------- */
  function renderPrice(){
    var base = basePrice(state.cats);
    var first = base * 0.5;
    var recur = base * 0.8;
    var bags = state.cats, lbs = bags * 9, bw = bags > 1 ? "bags" : "bag";
    var catWord = bags > 1 ? bags + " cats" : "one cat";
    var _pps = $("planPriceSub"); if (_pps) _pps.textContent = fmt(base * 0.5) + " first box";
    var _ppo = $("planPriceOne"); if (_ppo) _ppo.textContent = fmt(base);
    if (state.plan === "sub") {
      $("planTitle").innerHTML = "Subscribe &amp; save";
      $("saveBadge").style.display = "";
      $("saveBadge").textContent = "Save " + fmt(base - first) + " today";
      $("wasPrice").textContent = fmt(base); $("wasPrice").style.display = "";
      $("bigPrice").textContent = fmt(first);
      $("dueCaption").textContent = "due today";
      $("recurRow").style.display = "";
      $("recurText").textContent = fmt(recur) + " every 4 weeks";
      var pn = recur / 30;
      $("perNight").innerHTML = "≈ " + (pn < 1 ? Math.round(pn * 100) + "¢/night" : "$" + pn.toFixed(2) + "/night");
      $("ctaLabel").textContent = "Get my first box";
      $("ctaPrice").textContent = fmt(first);
      $("stickyPrice").textContent = fmt(first);
      $("stickySub").textContent = "then " + fmt(recur) + " every 4 weeks";
      $("riskMidRow").style.display = "";
      var _rf = $("pcRiskFree"); if (_rf) _rf.innerHTML = "<b>Cancel anytime — even after box one.</b> One tap in your account — no calls, no fees.";
      $("priceMeta").innerHTML = bags + " " + bw + " &middot; " + lbs + " lb &mdash; about a month for " + catWord;
    } else {
      $("planTitle").textContent = "One-time purchase";
      $("saveBadge").style.display = "none";
      $("wasPrice").style.display = "none";
      $("bigPrice").textContent = fmt(base);
      $("dueCaption").textContent = "ships once · no subscription";
      $("recurRow").style.display = "none";
      $("ctaLabel").textContent = "Add to cart";
      $("ctaPrice").textContent = fmt(base);
      $("stickyPrice").textContent = fmt(base);
      $("stickySub").textContent = "one-time";
      $("riskMidRow").style.display = "none";
      var _rf1 = $("pcRiskFree"); if (_rf1) _rf1.innerHTML = "<b>30 nights to love it — or a full refund.</b> Keep the bag either way.";
      $("priceMeta").innerHTML = bags + " " + bw + " &middot; " + lbs + " lb";
    }
  }

  /* ---------- cat selector ---------- */
  function moveSegThumb(seg, thumb, index, count){
    thumb.style.left = "calc(6px + " + index + " * (100% - 12px) / " + count + ")";
    thumb.style.width = "calc((100% - 12px) / " + count + ")";
  }
  function renderCats(){
    var seg = $("catSeg");
    var btns = seg.querySelectorAll("button");
    var idx = state.cats <= 1 ? 0 : (state.cats === 2 ? 1 : (state.cats === 3 ? 2 : 3));
    btns.forEach(function(b,i){ b.classList.toggle("on", i === idx); });
    moveSegThumb(seg, $("catThumb"), idx, 4);
    var stepper = $("catStepper");
    if (state.cats >= 4) { stepper.style.display = "flex"; $("catNum").textContent = state.cats; }
    else { stepper.style.display = "none"; }
    var sn = $("sbNum"); if (sn) { sn.textContent = state.cats; var su = $("sbUnit"); if (su) su.textContent = state.cats > 1 ? " cats" : " cat"; }
    renderPrice();
  }
  $("catSeg").addEventListener("click", function(e){
    var b = e.target.closest("button[data-cats]");
    if (!b) return;
    var c = parseInt(b.getAttribute("data-cats"), 10);
    if (c === 4) { state.cats = (state.cats >= 4) ? state.cats : lastFourPlus; }  // 4+ : keep current value if already >=4, else restore last remembered 4+ value
    else { state.cats = c; }
    renderCats();
  });
  $("catDec").addEventListener("click", function(){ if (state.cats > 4) { state.cats--; lastFourPlus = state.cats; renderCats(); } });
  $("catInc").addEventListener("click", function(){ if (state.cats < 12) { state.cats++; lastFourPlus = state.cats; renderCats(); } });
  var sbD = $("sbDec"), sbI = $("sbInc");
  if (sbD) sbD.addEventListener("click", function(){ if (state.cats > 1) { state.cats--; if (state.cats >= 4) lastFourPlus = state.cats; renderCats(); } });
  if (sbI) sbI.addEventListener("click", function(){ if (state.cats < 12) { state.cats++; if (state.cats >= 4) lastFourPlus = state.cats; renderCats(); } });

  /* ---------- plan toggle ---------- */
  function renderPlan(){
    var seg = $("planSeg");
    var btns = seg.querySelectorAll("button");
    var idx = state.plan === "sub" ? 0 : 1;
    btns.forEach(function(b,i){ b.classList.toggle("on", i === idx); });
    moveSegThumb(seg, $("planThumb"), idx, 2);
    renderPrice();
  }
  $("planSeg").addEventListener("click", function(e){
    var b = e.target.closest("button[data-plan]");
    if (!b) return;
    state.plan = b.getAttribute("data-plan");
    renderPlan();
  });

  /* ---------- buy-fold accordions ---------- */
  document.querySelectorAll(".acc-btn").forEach(function(btn){
    btn.addEventListener("click", function(){
      var key = btn.getAttribute("data-acc");
      var body = key === "benefits" ? $("accBenefits") : $("accIngredients");
      var open = body.classList.toggle("open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.querySelector(".sign").innerHTML = open ? "&ndash;" : "+";
    });
  });

  /* ---------- hero gallery ---------- */
  var heroScroll = $("heroScroll");
  var slideCount = heroScroll.children.length;
  var thumbSrcs = ["https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-pouch.jpg?v=1782803016","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/kind-litter-paw.jpg?v=1782803017","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-lifestyle.jpg?v=1782803022","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-granule.jpg?v=1782803016","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-pour.jpg?v=1782803016","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-water.jpg?v=1782803017","https://cdn.shopify.com/s/files/1/0725/9661/9432/files/hero-cat-benefits.jpg?v=1782803063"];
  var dotsWrap = $("heroDots"), thumbsWrap = $("heroThumbs");
  for (var i=0;i<slideCount;i++){
    (function(idx){
      var d = document.createElement("button");
      d.className = "herodot" + (idx===0?" active":"");
      d.setAttribute("aria-label","View photo "+(idx+1));
      d.addEventListener("click", function(){ goHero(idx); });
      dotsWrap.appendChild(d);
      var t = document.createElement("button");
      t.className = "thumb" + (idx===0?" active":"");
      t.setAttribute("aria-label","View photo "+(idx+1));
      var img = document.createElement("img"); img.src = thumbSrcs[idx] + "&width=160"; img.alt=""; img.loading="lazy"; img.decoding="async";
      t.appendChild(img);
      t.addEventListener("click", function(){ goHero(idx); });
      thumbsWrap.appendChild(t);
    })(i);
  }
  function goHero(idx){
    var w = heroScroll.clientWidth;
    heroScroll.scrollTo({ left: idx * w, behavior: "smooth" });
    setActiveHero(idx);
  }
  function setActiveHero(idx){
    dotsWrap.querySelectorAll(".herodot").forEach(function(d,i){ d.classList.toggle("active", i===idx); });
    thumbsWrap.querySelectorAll("button").forEach(function(t,i){ t.classList.toggle("active", i===idx); });
  }
  var heroTick = null;
  heroScroll.addEventListener("scroll", function(){
    if (heroTick) return;
    heroTick = requestAnimationFrame(function(){
      heroTick = null;
      var idx = Math.round(heroScroll.scrollLeft / heroScroll.clientWidth);
      setActiveHero(idx);
    });
  });

  /* ---------- trust marquee ---------- */
  var trustItems = [
    {svg:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1B2E72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/></svg>', t:"Plant-based"},
    {svg:'<svg width="15" height="15" viewBox="0 0 24 24" fill="#1B2E72"><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/></svg>', t:"Ultra-low dust"},
    {svg:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1B2E72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.8 19.6A2 2 0 1 0 14 16H2"/><path d="M17.5 8a2.5 2.5 0 1 1 2 4H2"/><path d="M9.8 4.4A2 2 0 1 1 11 8H2"/></svg>', t:"Natural odor control"},
    {svg:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1B2E72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>', t:"Fast clumping"},
    {svg:'<svg width="16" height="16" viewBox="0 0 24 24" fill="#1B2E72"><ellipse cx="5.5" cy="12" rx="1.7" ry="2.2"/><ellipse cx="9.5" cy="8.2" rx="1.8" ry="2.4"/><ellipse cx="14.5" cy="8.2" rx="1.8" ry="2.4"/><ellipse cx="18.5" cy="12" rx="1.7" ry="2.2"/><path d="M12 12.5c-2.9 0-5.2 2.2-5.2 4.6 0 1.7 1.4 2.7 3 2.2.8-.26 1.5-.45 2.2-.45s1.4.19 2.2.45c1.6.5 3-.5 3-2.2 0-2.4-2.3-4.6-5.2-4.6z"/></svg>', t:"20,000+ cats"}
  ];
  (function(){
    var html = "";
    function seq(){
      var s = "";
      trustItems.forEach(function(it){
        s += '<span class="trust-item">' + it.svg + " " + it.t + "</span><span class=\"trust-sep\">/</span>";
      });
      return s;
    }
    var __tt = $("trustTrack"); if (__tt) __tt.innerHTML = seq() + seq();
  })();

  /* ---------- free from chips ---------- */
  (function(){
    var x = '<svg width="12" height="12" viewBox="0 0 20 20"><path d="M5 5l10 10M15 5L5 15" stroke="#C2705F" stroke-width="2.4" stroke-linecap="round"></path></svg>';
    var items = ["Harsh chemicals","Silica dust","Synthetic fragrance","Irritants","Dyes"];
    var __ff = $("freeFromChips"); if (__ff) __ff.innerHTML = items.map(function(t){ return '<span class="ff-chip">'+x+" "+t+"</span>"; }).join("");
  })();

  /* ---------- comparison table (built in JS for clean desktop layout) ---------- */
  (function(){
    var rows = ["Made from","Ultra-low dust","Lightweight","Fast clumping","Odor control","Flushable*","Soft on paws"];
    // value codes: 'y' full yes, 'n' no, or number 1-5 for odor; 'made' uses text label
    var cols = [
      { name:"Furrly", furrly:true, made:"Tofu", v:["y","y","y",5,"y","y"] },
      { name:"Clay", made:"Clay", v:["n","n","y",3,"n","n"] },
      { name:"Crystal", made:"Silica", v:["y","y","n",4,"n","n"] },
      { name:"Pine", made:"Pine", v:["y","y","n",3,"n","n"] },
      { name:"Walnut", made:"Walnut", v:["n","n","y",4,"n","n"] },
      { name:"Paper", made:"Paper", v:["y","y","n",2,"n","y"] }
    ];
    function dot(yes, glow){ return '<span role="img" aria-label="'+(yes?"Yes":"No")+'" class="'+(yes?"yes"+(glow?" glow":""):"no")+'"></span>'; }
    function rate(n, glow){
      var s = '<span class="rate" role="img" aria-label="'+n+' out of 5">';
      for (var i=0;i<5;i++){ s += '<i class="'+(i<n?(glow?"g":""):"o")+'"></i>'; }
      return s + "</span>";
    }
    var html = "";
    // label column
    html += '<div class="cmp-col-label"><div class="cmp-head"></div>';
    rows.forEach(function(r){ html += '<div class="cmp-cell lab">'+r+"</div>"; });
    html += "</div>";
    // data columns
    cols.forEach(function(c){
      var glow = !!c.furrly;
      if (c.furrly){
        html += '<div class="cmp-col-furrly"><div class="cmp-head"><span style="display:inline-flex;align-items:center;border:1px solid rgba(255,255,255,0.6);border-radius:999px;padding:6px 13px;background:rgba(255,255,255,0.10);"><img src="https://cdn.shopify.com/s/files/1/0725/9661/9432/files/furrly-logo-light.png?v=1782803063&width=200" alt="Furrly" style="height:12px;width:auto;display:block;"></span></div>';
        html += '<div class="cmp-cell"><span style="font-size:12.5px;font-weight:700;color:#fff;">'+c.made+"</span></div>";
      } else {
        html += '<div class="cmp-col"><div class="cmp-head">'+c.name+"</div>";
        html += '<div class="cmp-cell"><span style="font-size:12.5px;font-weight:500;color:rgba(255,255,255,0.55);">'+c.made+"</span></div>";
      }
      c.v.forEach(function(val){
        var cell;
        if (typeof val === "number") cell = rate(val, glow);
        else cell = dot(val === "y", glow);
        html += '<div class="cmp-cell">'+cell+"</div>";
      });
      html += "</div>";
    });
    $("cmpTable").innerHTML = html;
    $("cmpTable").setAttribute("role", "table");
    $("cmpTable").setAttribute("aria-label", "How Furrly compares with clay, crystal, pine, walnut, and paper litter");
  })();

  /* ---------- photo rail ---------- */
  (function(){
    var photos = [
      {img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-1.jpg?v=1782815260",n:"Foxhouzer",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-2.jpg?v=1782815261",n:"Brendan",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-3.jpg?v=1782803063",n:"Cassandra Taylor",s:5},
      {img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-4.jpg?v=1782815261",n:"Miss Kirk",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-5.jpg?v=1782803016",n:"Sanne Kuijpers",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-6.jpg?v=1782803022",n:"Victoria",s:5},
      {img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-7.jpg?v=1782815260",n:"Sara Maloney",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-8.jpg?v=1782815261",n:"Shannon Shea",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-9.jpg?v=1782815260",n:"Zack P",s:5},
      {img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-10.jpg?v=1782803063",n:"Christa",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-11.jpg?v=1782803017",n:"Sonnii",s:5},{img:"https://cdn.shopify.com/s/files/1/0725/9661/9432/files/rev-12.jpg?v=1782815261",n:"Angel Alvarez",s:5}
    ];
    var star = "★";
    $("rvRail").innerHTML = photos.map(function(p){
      return '<div class="rv-photo"><img src="'+p.img+'&width=360" alt="Cat parent photo from '+p.n+'" loading="lazy" decoding="async"><div class="meta"><div class="nm">'+p.n+'</div><div class="st">'+star.repeat(p.s)+'</div></div></div>';
    }).join("");
  })();

  /* ---------- text review cards (paginated, loaded from JSON asset) ---------- */
  (function(){
    var reviews = [];
    var star = "&#9733;";
    var RVPP = 6, rvCur = 1, rvTot = 1;
    var MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    function rvFmtDate(d){ if(!d) return ""; var t=Date.parse(d); if(isNaN(t)) return ""; var dt=new Date(t); return MON[dt.getUTCMonth()]+" "+dt.getUTCDate()+", "+dt.getUTCFullYear(); }
    function rvCard(r){ return '<div class="rv-card"><div class="top"><span class="st">'+star.repeat(r.s)+'</span><span class="dt">'+rvFmtDate(r.d)+'</span></div><p class="rv-txt clamp">&#8220;'+r.t+'&#8221;</p><button type="button" class="rv-more" aria-expanded="false" hidden>Read more</button><div class="who">'+r.n+' <span class="vb">&#10003; Verified buyer</span> <span class="loc">&middot; United States</span></div></div>'; }
    /* category rating bars — computed live from the genuine review text (mention + average star) */
    function rvCatsRender(){
      var el=$("rvCats"); if(!el) return;
      var defs=[["Odor control",/odor|smell|stink|stench|scent/],["Easy clumping",/clump/],["Low tracking",/track/],["Low dust",/dust/],["Value for money",/worth|value|price|expensive|cost|pricey/]];
      el.innerHTML=defs.map(function(d){
        var m=reviews.filter(function(r){return d[1].test((r.t||"").toLowerCase());});
        if(!m.length) return "";
        var avg=m.reduce(function(a,r){return a+(r.s||0);},0)/m.length;
        return '<div class="rv-cat"><span class="rv-cat-l">'+d[0]+'</span><span class="rv-cat-bar" aria-hidden="true"><i style="width:'+(avg/5*100).toFixed(1)+'%"></i></span><span class="rv-cat-v">'+avg.toFixed(1)+'</span></div>';
      }).join("");
    }
    function rvWin(n){var w=[],o=[],last=0;function a(x){if(x>=1&&x<=rvTot&&w.indexOf(x)<0)w.push(x);}a(1);a(n-1);a(n);a(n+1);a(rvTot);w.sort(function(p,q){return p-q;});w.forEach(function(x){if(x-last>1)o.push("e");o.push(x);last=x;});return o;}
    function rvPagerHTML(){if(rvTot<=1)return "";var h='<button class="rv-pg ar" data-go="prev"'+(rvCur<=1?" disabled":"")+'>&#8249;</button>';rvWin(rvCur).forEach(function(t){if(t==="e")h+='<span class="rv-pg el">&#8230;</span>';else h+='<button class="rv-pg'+(t===rvCur?" on":"")+'" data-go="'+t+'">'+t+'</button>';});h+='<button class="rv-pg ar" data-go="next"'+(rvCur>=rvTot?" disabled":"")+'>&#8250;</button>';return '<div class="rv-pg-track">'+h+'</div>';}
    function rvShow(scroll){var s=(rvCur-1)*RVPP;$("rvCards").innerHTML=reviews.slice(s,s+RVPP).map(rvCard).join("");rvClampInit();$("rvPager").innerHTML=rvPagerHTML();if(scroll)$("reviews").scrollIntoView({behavior:"smooth"});}
    /* show a "Read more" toggle only on cards whose text actually overflows the collapsed height */
    function rvClampInit(){var cards=$("rvCards").querySelectorAll(".rv-card");var ps=[],btns=[];for(var i=0;i<cards.length;i++){var p=cards[i].querySelector(".rv-txt"),btn=cards[i].querySelector(".rv-more");if(!p||!btn)continue;p.classList.add("clamp");btn.textContent="Read more";btn.setAttribute("aria-expanded","false");ps.push(p);btns.push(btn);}var hide=[];for(var j=0;j<ps.length;j++){hide.push(ps[j].scrollHeight-ps[j].clientHeight<=2);}for(var k=0;k<btns.length;k++){btns[k].hidden=hide[k];}}
    $("rvCards").addEventListener("click",function(e){var btn=e.target.closest(".rv-more");if(!btn)return;var p=btn.closest(".rv-card").querySelector(".rv-txt");var collapsed=p.classList.toggle("clamp");btn.textContent=collapsed?"Read more":"Read less";btn.setAttribute("aria-expanded",collapsed?"false":"true");});
    $("rvPager").addEventListener("click",function(e){var b=e.target.closest("[data-go]");if(!b)return;var g=b.getAttribute("data-go");if(g==="prev")rvCur=Math.max(1,rvCur-1);else if(g==="next")rvCur=Math.min(rvTot,rvCur+1);else rvCur=+g;rvShow(true);});
    /* ----- sort by date added (newest first) -----
       When a review carries a date in `d` it drives the order. Reviews with no
       parseable date fall back to JSON order; the export is treated as
       oldest-first, so those are reversed to surface the most recently added
       first. If your JSON is already stored newest-first, set this to false. */
    var RV_JSON_OLDEST_FIRST = true;
    function rvParseDate(d){if(!d)return null;var t=Date.parse(d);return isNaN(t)?null:t;}
    function rvSorted(list){var ix=list.map(function(r,i){return {r:r,i:i,t:rvParseDate(r.d)};});ix.sort(function(a,b){if(a.t!==null&&b.t!==null)return b.t!==a.t?b.t-a.t:a.i-b.i;if(a.t!==null)return -1;if(b.t!==null)return 1;return RV_JSON_OLDEST_FIRST?b.i-a.i:a.i-b.i;});return ix.map(function(x){return x.r;});}
    function rvFail(){ var c=$("rvCards"); if(c) c.innerHTML='<p class="rv-empty">Our reviews are taking a moment to load &mdash; please refresh the page, or email <a href="mailto:meow@getfurrly.com">meow@getfurrly.com</a>.</p>'; var p=$("rvPager"); if(p) p.innerHTML=""; }
    var RURL=(window.FURRLY_REVIEWS_URL||"furrly-reviews.json");
    function rvLoad(){
    fetch(RURL).then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); }).then(function(d){reviews=rvSorted(d&&d.length?d:[]); if(!reviews.length){ rvFail(); return; } rvTot=Math.max(1,Math.ceil(reviews.length/RVPP));rvCur=1;rvShow(false);rvCatsRender();}).catch(function(e){ if(window.console&&console.error) console.error("Furrly: reviews failed to load —", e); rvFail(); });
    }
    if ("requestIdleCallback" in window) { requestIdleCallback(rvLoad, {timeout:2000}); } else { setTimeout(rvLoad, 1); }
  })();

  /* ---------- FAQ ---------- */
  (function(){
    var faqs = [
      {q:"What is Furrly made of?",a:"Four plant-based ingredients: soybean fiber, pea powder, guar gum, and water. No clay, no silica dust, no synthetic fragrance, and no harsh chemicals."},
      {q:"How is it different from clay litter?",a:"Clay is strip-mined, heavy, and dusty. Furrly is made from upcycled soybean fiber — the same plant protein behind tofu — so it’s lightweight, ultra-low dust, fast-clumping, and soft on paws."},
      {q:"Does it really control odor?",a:"Yes. The plant fibers absorb and lock in urine odor without perfumes or harsh chemicals. Scoop daily and the box stays fresh — and remove solids promptly, since no litter masks those forever."},
      {q:"Is it safe for kittens & multiple cats?",a:"Yes. It’s low-dust and made from food-grade plant ingredients, so it’s a great fit for kittens, senior cats, and busy multi-cat homes."},
      {q:"Can I flush it?",a:"Urine clumps are flushable where your plumbing and local codes allow. Always put solid waste in the trash — never flush it. If you’re on a septic system, check your guidance first."},
      {q:"How does the subscription work?",a:"Tell us how many cats you have and we ship the right amount on your schedule — 50% off your first order, 20% off every order after, with free shipping. Skip, pause, or cancel anytime."},
      {q:"How long does it take to clump?",a:"Give pee clumps about 2–3 minutes to set firm before scooping — solids you can scoop right away. That short wait is what lets the clump lift out clean instead of crumbling."},
      {q:"Will it work in my automatic litter box?",a:"Yes — Furrly works in robots like the Litter-Robot. Give fresh clumps a few extra minutes to harden before a cycle runs so they don’t break apart."},
      {q:"How much do I need, and how long does a bag last?",a:"Fill the box 2–3 inches deep. One 9 lb bag lasts about a month per cat with daily scooping."}
    ];
    $("faqList").innerHTML = faqs.map(function(f){
      return '<div class="faq-item"><button class="faq-q" type="button" aria-expanded="false"><span>'+f.q+'</span><span class="sign">+</span></button>'
        + '<div class="faq-a"><div class="inner">'+f.a+'</div></div></div>';
    }).join("") + '<a class="faq-all" href="/pages/faq">See all FAQs &#8594;</a>';
    $("faqList").addEventListener("click", function(e){
      var btn = e.target.closest(".faq-q");
      if (!btn) return;
      var item = btn.parentElement;
      var open = item.classList.toggle("open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.querySelector(".sign").innerHTML = open ? "&ndash;" : "+";
    });
  })();

  /* ---------- menu ---------- */
  function openMenu(){ $("menuScrim").classList.add("show"); $("menuPanel").classList.add("show"); }
  function closeMenu(){ $("menuScrim").classList.remove("show"); $("menuPanel").classList.remove("show"); }
  $("openMenu").addEventListener("click", openMenu);
  $("closeMenu").addEventListener("click", closeMenu);
  $("menuScrim").addEventListener("click", closeMenu);
  $("menuPanel").addEventListener("click", function(e){
    var b = e.target.closest("[data-nav]");
    if (!b) return;
    closeMenu();
    var target = $(b.getAttribute("data-nav"));
    if (target) target.scrollIntoView({ behavior:"smooth", block:"start" });
  });

  /* ---------- cart open (just opens checkout demo via toast for standalone) ---------- */
  /* ---------- cart drawer ---------- */
  var demoCart = [];
  function cartMoney(c){ return "$" + (c/100).toFixed(2); }
  function cdSetCount(n){ var cc=$("cartCount"), cd=$("cartDot"); var prev=state.cartCount; state.cartCount=n; if(cc && n>prev){ cc.classList.remove("bump"); void cc.offsetWidth; cc.classList.add("bump"); } if(cc) cc.setAttribute("aria-label", n+" item"+(n===1?"":"s")+" in cart"); if(n>0){ if(cc){ cc.textContent=n; cc.style.display="flex"; } if(cd) cd.style.display="none"; } else { if(cc) cc.style.display="none"; if(cd) cd.style.display=""; } }
  function cdShow(){ $("cartScrim").classList.add("show"); $("cartDrawer").classList.add("show"); }
  function cdHide(){ $("cartScrim").classList.remove("show"); $("cartDrawer").classList.remove("show"); }
  function cdRenderItems(items, subtotalCents, count){
    var body=$("cdBody");
    if(!items.length){ body.innerHTML='<div class="cd-empty"><div class="cd-empty-ic">&#128717;</div><p>Your cart is empty.</p><button class="cd-shop" type="button">Shop Kind Litter</button></div>'; $("cdFoot").style.display="none"; cdSetCount(0); return; }
    $("cdFoot").style.display="";
    body.innerHTML = items.map(function(it){
      var qty = it.key ? ('<button class="cd-q" type="button" data-key="'+it.key+'" data-q="'+(it.qty-1)+'">&minus;</button><span>'+it.qty+'</span><button class="cd-q" type="button" data-key="'+it.key+'" data-q="'+(it.qty+1)+'">+</button>') : ('<span>Qty '+it.qty+'</span>');
      return '<div class="cd-item"><div class="cd-thumb"><img src="'+it.img+'" alt=""></div><div class="cd-info"><div class="cd-name">'+it.title+'</div><div class="cd-sub">'+it.sub+'</div><div class="cd-qty">'+qty+'</div></div><div class="cd-price">'+it.price+'</div></div>';
    }).join("");
    $("cdSubtotal").textContent = cartMoney(subtotalCents);
    cdSetCount(count);
  }
  function cdFromShopify(cart){
    var items=(cart.items||[]).map(function(i){
      var sub=(i.options_with_values||[]).map(function(o){return o.value;}).join(" / ");
      if(i.selling_plan_allocation && i.selling_plan_allocation.selling_plan){ sub=(sub?sub+" \u00b7 ":"")+i.selling_plan_allocation.selling_plan.name; }
      return {title:(i.product_title||i.title), sub:sub, img:(i.image||""), qty:i.quantity, price:cartMoney(i.final_line_price), key:i.key};
    });
    var st=(cart.items_subtotal_price!=null?cart.items_subtotal_price:cart.total_price);
    cdRenderItems(items, st, cart.item_count);
  }
  function cdFromDemo(){
    var items=demoCart.map(function(d){ return {title:d.title, sub:d.sub, img:d.img, qty:d.qty, price:"$"+(d.price*d.qty).toFixed(2), key:null}; });
    var sub=demoCart.reduce(function(a,d){return a+d.price*d.qty;},0);
    var cnt=demoCart.reduce(function(a,d){return a+d.qty;},0);
    cdRenderItems(items, Math.round(sub*100), cnt);
  }
  function openCartDrawer(){ cdShow(); fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(cdFromShopify).catch(cdFromDemo); }
  $("openCart").addEventListener("click", openCartDrawer);
  $("closeCart").addEventListener("click", cdHide);
  $("cartScrim").addEventListener("click", cdHide);
  $("cdBody").addEventListener("click", function(e){
    var q=e.target.closest(".cd-q");
    if(q){ var key=q.getAttribute("data-key"), nq=parseInt(q.getAttribute("data-q"),10);
      fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:nq})}).then(function(r){return r.json();}).then(cdFromShopify).catch(function(){}); return; }
    var sh=e.target.closest(".cd-shop"); if(sh){ cdHide(); $("buyFold").scrollIntoView({behavior:"smooth",block:"start"}); }
  });

  /* ---------- scroll-to-buy ---------- */
  function scrollToBuy(){ $("buyFold").scrollIntoView({ behavior:"smooth", block:"start" }); }
  $("scrollToBuy").addEventListener("click", scrollToBuy);
  var __finalCtaBtn = $("finalCtaBtn"); if (__finalCtaBtn) __finalCtaBtn.addEventListener("click", scrollToBuy);
  $("scrollReviews").addEventListener("click", function(){ $("reviews").scrollIntoView({ behavior:"smooth" }); });

  /* ---------- toast ---------- */
  var toastTimer = null;
  function showToast(msg){
    var t = $("toast");
    t.textContent = msg || "Added to cart ✓";
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2200);
  }

  /* ---------- add to cart (Shopify-ready) ---------- */
  function addToCart(){
    var variantId = variantForCats(state.cats);
    var payload = { id: variantId, quantity: 1 };
    // Subscription: if a selling_plan id is configured, attach it.
    if (state.plan === "sub" && SUBSCRIPTION_SELLING_PLAN) {
      payload.selling_plan = SUBSCRIPTION_SELLING_PLAN;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function(res){
      if (!res.ok) throw new Error("add failed");
      openCartDrawer();
    }).catch(function(){
      // Running outside Shopify (preview) — demo gracefully.
      var __bp=basePrice(state.cats); var __pr=(state.plan==="sub"?__bp*0.5:__bp);
      demoCart.push({title:"Kind Tofu Cat Litter", sub:(state.plan==="sub"?"Subscribe & Save":"One-time")+" \u00b7 "+state.cats+(state.cats>1?" cats":" cat"), img:((document.querySelector(".heroslide img")||{}).src||""), price:__pr, qty:1});
      openCartDrawer();
      showToast("Added to cart ✓");
    });
  }
  /* ---------- cute add-to-cart celebration (2026-07-07) ---------- */
  var PAW_D = "M189.02051,145.33984A31.35052,31.35052,0,0,1,174.0918,126.606a47.99847,47.99847,0,0,0-92.18262-.00635,31.35,31.35,0,0,1-14.92969,18.74023,44.00739,44.00739,0,0,0,38.11719,79.21094,60.16331,60.16331,0,0,1,45.80664,0,44.00678,44.00678,0,0,0,38.11719-79.21094ZM168,204a19.86485,19.86485,0,0,1-7.80078-1.57568c-.04395-.019-.08887-.0376-.13379-.05616a84.02637,84.02637,0,0,0-64.13086,0c-.04492.01856-.08984.03711-.13379.05616a20.00673,20.00673,0,0,1-17.31445-36.02246c.03515-.01954.07129-.03907.10644-.05909A55.21137,55.21137,0,0,0,104.957,133.29541a23.99908,23.99908,0,0,1,46.08887.00439,55.20367,55.20367,0,0,0,26.36133,33.043c.03515.02.07129.03955.10644.05909A20.00364,20.00364,0,0,1,168,204Zm64-100a24,24,0,1,1-24-24A23.99994,23.99994,0,0,1,232,104ZM48,128a24,24,0,1,1,24-24A23.99994,23.99994,0,0,1,48,128ZM72,56A24,24,0,1,1,96,80,23.99994,23.99994,0,0,1,72,56Zm64,0a24,24,0,1,1,24,24A23.99994,23.99994,0,0,1,136,56Z";
  function ctaCelebrate(btn){
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var cat = document.querySelector(".pc-cat");
    if (cat) { cat.classList.remove("cheer"); void cat.offsetWidth; cat.classList.add("cheer"); setTimeout(function(){ cat.classList.remove("cheer"); }, 700); }
    if (!btn) return;
    btn.classList.remove("cta-pop"); void btn.offsetWidth; btn.classList.add("cta-pop");
    var wrap = document.createElement("span");
    wrap.className = "paw-burst";
    wrap.setAttribute("aria-hidden","true");
    for (var i=0;i<3;i++){
      var p = document.createElement("span");
      p.className = "paw-p paw-p"+(i+1);
      p.innerHTML = '<svg viewBox="0 0 256 256" fill="currentColor"><path d="'+PAW_D+'"/></svg>';
      wrap.appendChild(p);
    }
    btn.appendChild(wrap);
    setTimeout(function(){ if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 900);
  }
  document.querySelectorAll(".addBtn").forEach(function(b){ b.addEventListener("click", function(){ ctaCelebrate(b); addToCart(); }); });

  /* ---------- sticky bar visibility ---------- */
  var stickyBar = $("stickyBar");
  var buyFold = $("buyFold");
  var finalCta = $("finalCta");
  var headerPill = document.querySelector(".headerpill");
  function updateSticky(){
    if (buyFold && stickyBar) {
      var pastBuy = buyFold.getBoundingClientRect().bottom < 60;         // buy fold scrolled out of view
      var nearFinal = finalCta ? finalCta.getBoundingClientRect().top < window.innerHeight : false;
      stickyBar.classList.toggle("show", pastBuy && !nearFinal);
    }
    if (headerPill) headerPill.classList.toggle("scrolled", window.scrollY > 24);
  }
  var stickyTick = false;
  function onScroll(){ if (!stickyTick) { stickyTick = true; requestAnimationFrame(function(){ updateSticky(); stickyTick = false; }); } }
  window.addEventListener("scroll", onScroll, { passive:true });
  updateSticky();
  var rzT=null, rzW=window.innerWidth;
  window.addEventListener("resize", function(){
    clearTimeout(rzT);
    rzT=setTimeout(function(){
      if(window.innerWidth===rzW){ updateSticky(); return; }  /* height-only resize (mobile URL bar) - skip re-render */
      rzW=window.innerWidth;
      renderCats(); renderPlan(); updateSticky();
    },150);
  });

  /* ---------- init ---------- */
  renderCats();
  renderPlan();
  updateSticky();
})();

/* ---------- back-to-fold arrow (addition 2026-07-07) ---------- */
(function(){
  var btn = document.getElementById("toFold"), fold = document.getElementById("buyFold");
  if (!btn || !fold) return;
  btn.addEventListener("click", function(){
    var hdr = document.querySelector(".topwrap");
    var off = (hdr ? hdr.getBoundingClientRect().bottom : 0) + 6;   /* actual sticky-header height + breathing room */
    window.scrollTo({ top: Math.max(0, window.scrollY + fold.getBoundingClientRect().top - off), behavior: "smooth" });
  });
  var tick = false;
  function upd(){ btn.classList.toggle("show", fold.getBoundingClientRect().bottom < 60); }
  window.addEventListener("scroll", function(){ if (!tick){ tick = true; requestAnimationFrame(function(){ upd(); tick = false; }); } }, { passive:true });
  window.addEventListener("resize", upd);
  upd();
})();

/* ---------- pause off-screen looping animations (2026-07-07) ---------- */
(function(){
  if (!("IntersectionObserver" in window)) return;
  var els = [];
  var ts = document.querySelector(".truststrip"); if (ts) els.push(ts);
  var hw = document.querySelector(".herowrap");  if (hw) els.push(hw);
  var pc = document.querySelector(".pricecard"); if (pc) els.push(pc);
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ en.target.classList.toggle("animoff", !en.isIntersecting); });
  }, { rootMargin: "120px" });
  els.forEach(function(el){ io.observe(el); });
})();
